import APIURL from "../axios";
import { useQuery } from "react-query";

const Spa = async (room_uuid, lang) => {
  return await APIURL.get(`/${room_uuid}/spas`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang,
    },
  });
};

export const ShowSpas = (uuid, lang) => {
  return useQuery(["spas", uuid, lang], () => Spa(uuid, lang));
};

const SPA = async (uuid, spa_id, lang) => {
  return await APIURL.get(`/${uuid}/spa/${spa_id}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowSPA = (uuid, spa_id, lang) => {
  return useQuery(["spa", uuid, spa_id, lang], () => SPA(uuid, spa_id, lang));
};
